import { useContext } from 'react';
import { BoardContext } from '@/app/providers/BoardProvider';
import type { BoardContextValue } from '@/app/providers/BoardProvider';

export const useBoard = (): BoardContextValue => {
  const context = useContext(BoardContext);
  if (!context) throw new Error('useBoard must be used within BoardProvider');
  return context;
};
